import { ModalPopup } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';
import { ISurveyQuestionEditModel } from '../../models';

const StyledModalContent = styled.div`
	text-align: center;
`;
export interface IQuestionDeletionModalProps {
	submitModal: (question: ISurveyQuestionEditModel | null) => void;
	closeModal: () => void;
	isOpen: boolean;
	dimensionsText: string;
}

export const QuestionDeletionModal = (props: IQuestionDeletionModalProps) => {
	return (
		<ModalPopup
			isOpen={props.isOpen}
			title={'Warning'}
			primaryButtonText={'Continue'}
			secondaryButtonText={'Cancel'}
			contenthcentered={true}
			contentvcentered={true}
			contentfullwidth={true}
			onClosed={props.closeModal}
			onSubmit={props.submitModal}
			type={'lightbox'}
			headericon='warning'
			headericoncolor='#e00000'
		>
			<StyledModalContent>
				<b>This action cannot be undone</b>
				<br />
				<br />
				This question is associated with the dimension <b>{props.dimensionsText}</b>. If you remove <br />
				this question then any follow up questions with the response option <br />
				{props.dimensionsText} will be automatically removed.
			</StyledModalContent>
		</ModalPopup>
	);
};
